import { makeStyles } from "tss-react/mui";

export const FooterStyles = makeStyles()({
    footer: {
        position: "absolute",
        bottom: 0,
        zIndex: 1,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        background: "#3B78CE",
        padding: "16px 50px",
    },
    copyRightText: {
        color: "#FFFFFF",
        fontSize: "13px",
        fontWeight: "600",
        lineHeight: "18px",
        display: "flex",
        alignItems: "center",
    },
    site: {
        fontWeight: "600",
        fontSize: "13px",
        padding: "0px 20px",
        borderRight: "1px solid white",
        "@media screen and (max-width:899px)": {
            padding: "0px 20px 0px 0px !important",
        },
    },
    icon: {
        fontSize: "medium !important",
        margin: "0 3px !important",
    },
});